<template>
  <div>
    The TLE ΔV calculator allows you to input various TLEs from the same
    spacecraft and rapidly calculates the ΔV of the different orbital changes observed between consecutive TLEs.
    In addition, information about the different orbital changes are also displayed.
    <br />
    <br />
    The different steps to calculate the  ΔV are as follows: 
    <br />
     - The first TLE is propagated to the next consecutive TLE using SGP4 and SDP4 models. Then, mean orbits are calculated for both TLEs using the SGP4 model and the Brouwer mean semi major axis. If filtering option is selected, outliers are discarded at this time.
    <br />
     - The mean orbits are compared.
    <br />
     - The ΔV required to perform an orbital change is calculated if the difference in the semi major
    axis and/or the inclination higher than a predifined threshold (<katex-element expression="thr_{sma} = 200 m" /> and <katex-element expression="thr_{inc} = 0.01 \degree" />), .
    <br />
     - The process is repeated for the next TLE.
    <br />
    <br />
     ΔV calculations are performed utilizing the analytical model used in <i>Parametric Studies</i> module. Simple orbit transfers are carried out where maneuvers are supposed to be <b>impulsive</b>, to only take into account the orbital changes.
     In addition, the <b>drag perturbation</b> is not taken into account. 
    <br />
    <br />
    
  </div>
</template>

<script>
export default {
  name: 'tooltipTLEDeltaV'
}
</script>
